class UpsellVariantPicker {
  constructor(element) {
    this.element = element;
    this.cards = Array.from(element.querySelectorAll('.upsell-variant-picker__card'));
    this.hiddenInput = element.querySelector('[data-variant-input]');
    
    console.log('UpsellVariantPicker initialized', {
      element: element,
      cards: this.cards.length,
      hasInput: !!this.hiddenInput
    });
    
    this.init();
  }

  init() {
    if (!this.cards.length || !this.hiddenInput) {
      console.warn('UpsellVariantPicker: Missing cards or input', {
        cards: this.cards.length,
        hasInput: !!this.hiddenInput
      });
      return;
    }

    // Set up event listeners
    this.cards.forEach((card, index) => {
      card.addEventListener('click', (e) => {
        console.log('Card clicked:', index, card.dataset.variantId);
        this.selectCard(card);
      });
      card.addEventListener('keydown', (e) => this.handleKeydown(e, card));
    });

    console.log('Event listeners attached to', this.cards.length, 'cards');

    // Sync with URL parameter if present; otherwise do not auto-select
    this.syncWithUrl();
  }

  selectCard(card) {
    const variantId = card.dataset.variantId;
    
    console.log('Selecting variant:', variantId);
    
    // Update UI
    this.cards.forEach(c => {
      c.classList.remove('is-active');
      c.setAttribute('aria-checked', 'false');
    });
    
    card.classList.add('is-active');
    card.setAttribute('aria-checked', 'true');

    // Update hidden input
    this.hiddenInput.value = variantId;

    // Update the main product form variant input
    const formId = this.element.dataset.productFormId;
    if (formId) {
      const productForm = document.getElementById(formId);
      if (productForm) {
        // Update all variant ID inputs (both in form and associated with form)
        const allVariantInputs = document.querySelectorAll(`input[name="id"][form="${formId}"], #${formId} input[name="id"]`);
        console.log('Found', allVariantInputs.length, 'variant inputs to update');
        
        allVariantInputs.forEach(input => {
          console.log('Updating input:', input, 'from', input.value, 'to', variantId);
          input.value = variantId;
        });
        
        // Dispatch change event on the form
        productForm.dispatchEvent(new Event('variant:change', { bubbles: true }));
      }
    }

    // Update URL for shareability
    this.updateUrl(variantId);

    // Trigger change event for product-info component
    this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    
    // Update product info display (price, availability, etc.)
    this.updateProductInfo(variantId);
    
    console.log('Variant updated to:', variantId);
  }

  handleKeydown(e, card) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.selectCard(card);
    }
    
    // Arrow key navigation
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      const currentIndex = this.cards.indexOf(card);
      let nextIndex;
      
      if (e.key === 'ArrowDown') {
        nextIndex = currentIndex + 1 >= this.cards.length ? 0 : currentIndex + 1;
      } else {
        nextIndex = currentIndex - 1 < 0 ? this.cards.length - 1 : currentIndex - 1;
      }
      
      this.cards[nextIndex].focus();
    }
  }

  syncWithUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    
    if (variantParam) {
      const matchingCard = this.cards.find(card => card.dataset.variantId === variantParam);
      if (matchingCard) {
        this.selectCard(matchingCard);
        return true;
      }
    }
    return false;
  }

  updateUrl(variantId) {
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }

  updateProductInfo(variantId) {
    // Find the product-info element (Dawn theme)
    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      // Trigger the setCurrentVariant method if it exists
      if (typeof productInfo.setCurrentVariant === 'function') {
        productInfo.setCurrentVariant(variantId);
      }
      
      // Dispatch variant change event on product-info
      productInfo.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant: variantId },
        bubbles: true
      }));
    }

    // Also trigger a global change event that product-info listens to
    const formId = this.element.dataset.productFormId;
    if (formId) {
      const form = document.getElementById(formId);
      if (form) {
        // Create and dispatch a change event on the form
        const changeEvent = new Event('change', { bubbles: true });
        form.dispatchEvent(changeEvent);
      }
    }

    // Update section if using section rendering
    const sectionId = document.querySelector('[data-section]')?.dataset.section;
    if (sectionId && variantId) {
      this.updateSectionContent(sectionId, variantId);
    }
  }

  updateSectionContent(sectionId, variantId) {
    // Fetch the section with the new variant to update price, etc.
    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
    
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Update price
        const newPrice = doc.querySelector('#price-' + sectionId);
        const currentPrice = document.querySelector('#price-' + sectionId);
        if (newPrice && currentPrice) {
          currentPrice.innerHTML = newPrice.innerHTML;
        }

        // Update inventory status
        const newInventory = doc.querySelector('#Inventory-' + sectionId);
        const currentInventory = document.querySelector('#Inventory-' + sectionId);
        if (newInventory && currentInventory) {
          currentInventory.innerHTML = newInventory.innerHTML;
        }

        // Update SKU if present
        const newSku = doc.querySelector('#Sku-' + sectionId);
        const currentSku = document.querySelector('#Sku-' + sectionId);
        if (newSku && currentSku) {
          currentSku.innerHTML = newSku.innerHTML;
        }

        console.log('Product info updated from section render');
      })
      .catch(error => {
        console.warn('Failed to update section:', error);
      });
  }
}

// Initialize function
function initUpsellPickers() {
  console.log('Initializing upsell pickers...');
  
  // Look for both the wrapper and the inner div
  const wrappers = document.querySelectorAll('upsell-variant-picker');
  const pickers = document.querySelectorAll('.upsell-variant-picker');
  
  console.log('Found', wrappers.length, 'wrappers and', pickers.length, 'pickers');
  
  pickers.forEach((picker, index) => {
    // Check if already initialized
    if (picker.dataset.upsellInitialized) {
      console.log('Picker', index, 'already initialized');
      return;
    }
    
    picker.dataset.upsellInitialized = 'true';
    console.log('Initializing picker', index);
    new UpsellVariantPicker(picker);
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUpsellPickers);
} else {
  initUpsellPickers();
}

// Also try after a short delay to catch any dynamically loaded content
setTimeout(initUpsellPickers, 100);

